import { render, staticRenderFns } from "./cdwriserrelat.vue?vue&type=template&id=c6ca17a2&scoped=true&"
import script from "./cdwriserrelat.vue?vue&type=script&lang=js&"
export * from "./cdwriserrelat.vue?vue&type=script&lang=js&"
import style0 from "./cdwriserrelat.vue?vue&type=style&index=0&id=c6ca17a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ca17a2",
  null
  
)

export default component.exports